module.exports = __webpack_public_path__ + "static/media/amex.34f9a14b.svg";